export default __webpack_public_path__ + "static/media/rightArrow.4d08fc01.svg";